import { observable } from '@legendapp/state';
import { type CartItemReferenceLogic } from '../models/types/cart-item-reference-logic';

export type AttachedProductsStore = {
    items: CartItemReferenceLogic[];
    cartItemReferenceId?: string;
};

export const attachedProductsStore$ = observable<AttachedProductsStore>({
    items: [],
});
